module.exports = __webpack_public_path__ + "img/icon_users.9861930a.svg";